import request from "@/utils/request";

export function fetchExample() {
  return request({
    url: 'user/center/api/instance/all/running/list',
    method: 'post'
  })
}

export function fetchList(param) {
  return request({
    url: 'user/center/api/instance/list',
    method: 'post',
    data: param
  })
}

export function deleteList(param) {
  return request({
    url: 'user/center/api/instance/release',
    method: 'post',
    data: param
  })
}

export function restart(param) {
  return request({
    url: 'user/center/api/instance/restart',
    method: 'post',
    data: param
  })
}

export function setPwd(param) {
  return request({
    url: 'user/center/api/instance/set/password',
    method: 'post',
    data: param
  })
}

export function fetchDetail(param) {
  return request({
    url: 'user/center/api/instance/query/one',
    method: 'post',
    data: param
  })
}

export function statistics(param) {
  return request({
    url: 'user/center/api/instance/statistics',
    method: 'post',
    data: param
  })
}

export function delaySpec(param) {
  return request({
    url: 'user/center/api/renewal/instance/options',
    method: 'post',
	data: param
  })
}

export function delayOrder(param) {
  return request({
    url: 'user/center/api/instance/renewal',
    method: 'post',
	data: param
  })
}

export function upgradeSpec(param) {
  return request({
    url: 'user/center/api/query/upgrade/info',
    method: 'post',
	data: param
  })
}

export function upgradePrice(param) {
  return request({
    url: 'user/center/api/price/difference',
    method: 'post',
	data: param
  })
}

export function upgradeOrder(param) {
  return request({
    url: 'user/center/api/upgrade/instance',
    method: 'post',
	data: param
  })
}

export function autoRenewalSubmit(param) {
  return request({
    url: 'user/center/api/instance/auto/renewal',
    method: 'post',
	data: param
  })
}
